'use client'

import { useEffect } from 'react'

/**
 * Render this component on any page that has a full-bleed hero image
 * directly behind the header. It signals the header to be transparent
 * until the user scrolls down.
 */
export function TransparentHeader() {
  useEffect(() => {
    ;(window as Window & { __transparentHeader?: boolean }).__transparentHeader = true
    window.dispatchEvent(new Event('transparent-header-change'))
    return () => {
      ;(window as Window & { __transparentHeader?: boolean }).__transparentHeader = false
      window.dispatchEvent(new Event('transparent-header-change'))
    }
  }, [])
  return null
}
